import { setUpSettings } from '../../../constant/constant'
import { useDispatch, useSelector } from 'react-redux'
import { selectSetup, selectSetupId, setSelectedSetup } from '../../../features/system/systemSlice'
import SetupCategory from '../../common/setup/SetupCategory'
import SetupTemperature from '../../common/setup/SetupTemperature'
import SetupAddons from '../../common/setup/SetupAddons'
import SetupSize from '../../common/setup/SetupSize'

export default function Setup() {

    const dispatch = useDispatch()
    const selectedSetup = useSelector(selectSetup)
    const selectedSetupId = useSelector(selectSetupId)

    return (
        <>
            {selectedSetup === null && (
                <div className='overflow-hidden h-full rounded'>
                <div className='grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-3 lg:grid-cols-5 lg:gap-3 overflow-hidden '>
                    {setUpSettings.map((set) => {
                        return (
                            <div 
                                onClick={() => dispatch(setSelectedSetup({ id: set.id, name: set.name }))}
                                key={set.id} 
                                className='rounded border-t-8 border-cbColor cursor-pointer bg-gray-100'
                            >
                                <div className='flex flex-col p-2.5 space-y-1 '>
                                    <div className='flex justify-between '>
                                        
                                        <p className='text-sm text-cbColorDark font-semibold truncate'>
                                            {set.name}
                                        </p>
                                    </div>
                                    <div className='flex'>
                                        <p className='text-sm truncate'>{set.description}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                </div>
            )}
            {selectedSetupId === 1 && (
                <SetupCategory/>
            )}
            {selectedSetupId === 2 && (
                <SetupTemperature/>
            )}
            {selectedSetupId === 3 && (
                <SetupAddons/>
            )}
            {selectedSetupId === 4 && (
                <SetupSize/>
            )}
        </>
    )
}
